import { render, staticRenderFns } from "./query-view.vue?vue&type=template&id=353c2c3a&"
import script from "./query-view.vue?vue&type=script&lang=js&"
export * from "./query-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports